import { colors } from '@revenuemarket/design';

import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function ArrowDown({
  width = 18,
  height = 18,
  fill = colors.grayscaleBlack,
  ...props
}: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.99982 11.0081C8.90944 11.0081 8.82532 10.9937 8.74744 10.9648C8.66957 10.9359 8.59551 10.8864 8.52526 10.8163L5.15457 7.44563C5.05082 7.34175 4.99769 7.21119 4.99519 7.05394C4.99282 6.89681 5.04594 6.76388 5.15457 6.65513C5.26332 6.5465 5.39507 6.49219 5.54982 6.49219C5.70457 6.49219 5.83632 6.5465 5.94507 6.65513L8.99982 9.71006L12.0546 6.65513C12.1584 6.55138 12.289 6.49825 12.4463 6.49575C12.6034 6.49338 12.7363 6.5465 12.8451 6.65513C12.9537 6.76388 13.008 6.89563 13.008 7.05038C13.008 7.20513 12.9537 7.33688 12.8451 7.44563L9.47438 10.8163C9.40413 10.8864 9.33007 10.9359 9.25219 10.9648C9.17432 10.9937 9.09019 11.0081 8.99982 11.0081Z"
        fill={fill}
      />
    </Svg>
  );
}
